import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    data-testid="tabs-list"
    className={cn(
      'inline-flex h-10 items-center justify-center py-2.5 border-b-[1px] border-zinc-800',
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
    hasDot?: boolean;
  }
>(({ className, hasDot, ...props }, ref) => (
  <div className="relative">
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(
        'min-w-[160px] inline-flex items-center justify-center text-zinc-500 whitespace-nowrap px-3 py-1.5 text-xl font-semibold ring-offset-background transition-all focus-visible:outline-none border-b-[1px] border-zinc-800 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-zinc-100 data-[state=active]:border-zinc-200',
        className
      )}
      data-testid={`tab-item-${props.value}`}
      {...props}
    />
    {hasDot && (
      <span className="absolute w-[10px] h-[10px] bg-destructive rounded-full right-0" />
    )}
  </div>
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'mt-5 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
